import { calculatePrices } from "../calculatePrices";
import { getProductPrice } from "../getProductPrice";
export const getOrderItemsWithFormattedPrice = (order, currency) => {
    var _a;
    if (!(order === null || order === void 0 ? void 0 : order.items)) {
        return undefined;
    }
    const orderItems = (_a = order.items) === null || _a === void 0 ? void 0 : _a.map((item) => (Object.assign(Object.assign({}, item), { price: getProductPrice(item, currency) })));
    const prices = (order === null || order === void 0 ? void 0 : order.prices) ? calculatePrices(order.prices, currency) : undefined;
    return Object.assign(Object.assign({}, order), { items: orderItems, prices });
};
//# sourceMappingURL=getOrderItemsWithFormattedPrice.js.map